import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-reject-budget-modal',
  templateUrl: 'reject-budget-modal.component.html',
  styleUrls: ['reject-budget-modal.component.scss']
})
export class RejectBudgetModalComponent implements OnInit {
  razon_rechazo = ""
  constructor(public dialogRef: MatDialogRef<RejectBudgetModalComponent>) { }

  ngOnInit() {
  }

  reject() {
    this.dialogRef.close({
      reject: true,
      razon_rechazo: this.razon_rechazo,
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/system/budget/reject-budget-modal/reject-budget-modal.component.ts